<script setup lang="ts">
import { computed } from "vue";
import { useImage } from "#imports";

const props = defineProps({
  background: {
    type: String,
    default: ""
  },
  isPaddedY: {
    type: Boolean,
    default: true
  },
  isPaddedX: {
    type: Boolean,
    default: true
  },
  parallax: {
    type: Boolean,
    default: false
  },
});

function isColor(val: string) {
  return (
      val.startsWith("#") ||
      val.startsWith("rgb") ||
      val.startsWith("hsl") ||
      val === "transparent" ||
      /^[a-zA-Z]+$/.test(val)
  );
}

const isImage = computed<boolean>(() => !isColor(props.background) && props.background !== "");
const $img = useImage();
const finalBgUrl = computed<string | undefined>(() =>
    isImage.value ? `url('${props.background}')` : undefined
);
</script>
<template>
  <section
    :class="{
      isPaddedY,
      isPaddedX,
      'has-background-image': isImage,
      'has-background-color': !isImage,
      'is-parallax': parallax,
    }"
    :style="{
      '--bg-image': finalBgUrl,
      '--bg-color': !isImage ? background : undefined,
    }"
  >
    <slot />
  </section>
</template>

<style scoped lang="scss">
section.has-background-image {
  background-image: var(--bg-image);
  background-size: cover;
  background-position: center;
}

section.has-background-color {
  background-color: var(--bg-color);
}

section.is-parallax.has-background-image {
  background-attachment: fixed;
}

section.isPaddedX {
  padding-left: 30px;
  padding-right: 30px;

  @media (min-width: 768px) {
    padding-left: 80px;
    padding-right: 80px;
  }

  @media (min-width: 1200px) {
    padding-left: 150px;
    padding-right: 150px;
  }
}

section.isPaddedY {
  padding-top: 80px;
  padding-bottom: 80px;
}
</style>
